<template>
  <section>
  	
  	 <el-row class="statusRow">
      <el-button size="medium" type="primary" @click="add">新增</el-button>
      <!--<el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>-->
   <!--   <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
		
     
		 
    </el-row>

    <el-table :data="list" >
     
       <el-table-column label="ID" prop="id" width="50px" align="center"></el-table-column>
       <el-table-column label="key" prop="k" width="250px" align="left"></el-table-column>
       <el-table-column label="value" prop="v"  align="left"></el-table-column>
       <el-table-column label="备注" prop="m" width="200px" align="left"></el-table-column>
       <el-table-column prop="ID"  label="操作" min-width="50px" width="150"  align="center">
     		 <template slot-scope="scope">
					      <el-button size="medium" type="primary" @click="edit(scope.row)">编辑</el-button>
     		 </template>
     </el-table-column>
    </el-table>
    <el-dialog :title="isAdd?'新增设置':'编辑设置'" :visible.sync="addDialog"  width="500px" :close-on-click-modal="false">
      <el-form  ref="form" :model="form">
        <el-form-item label="key">
			    <el-input v-model="form.k"></el-input>
			  </el-form-item>
			  <el-form-item label="value">
			    <el-input type="textarea" v-model="form.v" :autosize="{ minRows: 10, maxRows: 100}"></el-input>
			  </el-form-item>
			  <el-form-item label="备注">
			    <el-input v-model="form.m"></el-input>
			  </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { getSettingList, getSettingListByID,  saddSetting, seditSetting } from "../../api/api";
export default {
  data() {
    return {
      applist: [],
      list: [],
      pdata: {
        page: 1,
        perpage: 20,
        kw: ""
      },
      maxPage: 1,
      addDialog: false,
      inputKW: "",
      form: {
        "index_id":'',
				"k":"",
				"v":"",
				"m":""
      },
      isAdd: true
    };
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getSettingList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {

          this.list = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },

    submitAdd() {
      if (this.isAdd) {
      	this.form.index_id = "";
        if (this.form.k && this.form.v&&this.form.m) {
          saddSetting(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
              this.form.k = "";
              this.form.v = "";
              this.form.m = "";
            }
          });
        }
      } else {
      	
          seditSetting(this.form, this.$cookie.getCookie("login")).then(res => {
            if (res.code == 200) {
              this.getList();
              this.addDialog = false;
              this.form.index_id = "";
            } else {
              this.$message.error(res.msg);
            }
          });
     
      }
    },
    add() {
      this.isAdd = true;
      this.form = {  
      	"index_id":'',
    		"k":"",
				"v":"",
				"m":"" 
      };
      this.addDialog = true;
    },
    edit(s) {
      this.isAdd = false;
      var p ='index_id='+s.id
      getSettingListByID(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.form.index_id = s.id;
        }
      });
      this.addDialog = true;
    },
    select(s) {
      this.chooseList = s;
    }
  },
  mounted() {
    this.getList();
    this.applist = this.$store.applist;
  }
};
</script>




// WEBPACK FOOTER //
// device.vue?b8408c72